import { FormFieldContainer, RadioButtonsContainer, StyledLabel } from 'components/form-fields/shared-style'
import React, { useContext } from 'react'
import { formFieldNames } from '.'
import { StyledHeading, StyledPageHeader, StyledParagraph, StyledProcessText } from './style'
import CustomCheckBox from 'components/form-fields/checkbox'
import { useFormContext } from 'react-hook-form'
import { ProductContext } from 'context/productsContext'
import TextArea from 'components/form-fields/textArea'
import { translate } from 'locales/i18n'

const FormStep3: React.FC = () => {
  const { backendProducts } = useContext(ProductContext)

  const { watch } = useFormContext()

  const watchCurrentStep = watch(formFieldNames.CURRENT_STEP)
  const watchBackendFeatures = watch(formFieldNames.BACKEND_FEATURES)

  const selectedBackendFeatures = Object.keys(watchBackendFeatures).filter(key => watchBackendFeatures[key])

  return (
    <div>
      <StyledPageHeader>
        <div>
            <StyledHeading>{translate('forms.step3.heading')}</StyledHeading>
        </div>
        <StyledProcessText>{translate('forms.steps', { watchCurrentStep })}</StyledProcessText>
      </StyledPageHeader>
      <StyledParagraph>{translate('forms.step3.paragraph')}</StyledParagraph>
      <FormFieldContainer>
        <StyledLabel>{translate('forms.step3.cta')}</StyledLabel>
        <RadioButtonsContainer>
        {backendProducts.map((item) => {
          return (
            <CustomCheckBox
                key={item.id}
                name={`${formFieldNames.BACKEND_FEATURES}.${item.name}`}
                label={item.name}
                placeholder='Placeholder'
                value={item.id}
                isChecked={selectedBackendFeatures.includes(item.name)}
            />
          )
        })}
        </RadioButtonsContainer>
      </FormFieldContainer>
      <FormFieldContainer>
      <TextArea
        name={formFieldNames.DESCRIPTION}
        label={translate('forms.step3.userIdeaDescription')}
        placeholder=""
      />
  </FormFieldContainer>
  </div>
  )
}

export default FormStep3
